import { Buyer } from "../../../Models/Buyer";
import { Gig } from "../../../Models/Gig";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";
import { AuthAPIHandler } from "./AuthAPIHandler";

export interface BuyerResponseWithMessage {
    buyer: Buyer
    message: string
}

export class BuyerAPIHandler {
    
    public static shared = new BuyerAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared
    private buyerByAuthTokenRequest?: Promise<Buyer>

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async createBuyer(): Promise<Buyer> {
        
        let url = this.serverConfig.buyerAPIs.createBuyerAPI;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            
            let buyersResponse = await this.apiHandler.makeGetRequest(authHeaders, url); 
            let buyerData = buyersResponse.data.buyer;
            let buyer = new Buyer(buyerData);
            return Promise.resolve(buyer);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getBuyerByAuthToken(): Promise<Buyer> {

        if (this.buyerByAuthTokenRequest) return this.buyerByAuthTokenRequest;

        this.buyerByAuthTokenRequest = this.fetchBuyerByAuthToken();
        try {
            return await this.buyerByAuthTokenRequest;
        } finally {
            this.buyerByAuthTokenRequest = undefined;
        }
    }

    private async fetchBuyerByAuthToken(): Promise<Buyer> {

        let url = this.serverConfig.buyerAPIs.getBuyerByAuthTokenAPI;
        let authheaders = this.networkUtils.addAuthHeaders({});

        try {

            let buyersResponse = await this.apiHandler.makeGetRequest(authheaders, url);
            let buyerData = buyersResponse.data.buyer;
            let buyer = new Buyer(buyerData);
            return Promise.resolve(buyer);

        } catch (err) {
            return Promise.reject(err);
        }
    }


    public async getBuyerPublicById(id: string): Promise<Buyer> {

        let url = this.serverConfig.buyerAPIs.getBuyerPublicByIdAPI(id);
        let authheaders = this.networkUtils.addCommonHeaders({});

        try {

            let buyersResponse = await this.apiHandler.makeGetRequest(authheaders, url);
            let buyerData = buyersResponse.data.buyer;
            let buyer = new Buyer(buyerData);
            return Promise.resolve(buyer);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getFavouriteGigs(): Promise<Gig[]> {
        let url = this.serverConfig.buyerAPIs.favouritesAPI
        let authHeaders = this.networkUtils.addAuthHeaders({})

        try {
            let updatedBuyerResponse = await this.apiHandler.makeGetRequest(authHeaders, url)
            let gigListData = updatedBuyerResponse.data.gigList as Array<any> ?? [];
            let gigArray = gigListData.map((gigJson) => {
                return new Gig(gigJson);
            }) 
            return Promise.resolve(gigArray)
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async addGigToFavourites(gigId: string): Promise<BuyerResponseWithMessage> {
        let url = this.serverConfig.buyerAPIs.favouritesAPI
        let authHeaders = this.networkUtils.addAuthHeaders({})

        try {
            let updatedBuyerResponse = await this.apiHandler.makePostRequest(authHeaders, url, {gigId})
            let updatedBuyerData = updatedBuyerResponse.data.buyer
            let buyer = new Buyer(updatedBuyerData);
            let responseToSendBack: BuyerResponseWithMessage = {
                buyer: buyer,
                message: updatedBuyerResponse.data.message
            }
            return Promise.resolve(responseToSendBack)
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async removeGigFromFavourites(gigId: string): Promise<BuyerResponseWithMessage> {
        let url = this.serverConfig.buyerAPIs.favouritesAPI
        let authHeaders = this.networkUtils.addAuthHeaders({})

        try {
            let updatedBuyerResponse = await this.apiHandler.makeDeleteRequest(authHeaders, url, {gigId})
            let updatedBuyerData = updatedBuyerResponse.data.buyer
            let buyer = new Buyer(updatedBuyerData);
            let responseToSendBack: BuyerResponseWithMessage = {
                buyer: buyer,
                message: updatedBuyerResponse.data.message
            }
            return Promise.resolve(responseToSendBack)
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async sendOtpForResetPassword(email: String): Promise<void> {

        let url = this.serverConfig.buyerAPIs.sendOtpResetPasswordAPI + email;
        let headers = this.networkUtils.addCommonHeaders({});

        try {

            await this.apiHandler.makePostRequest(headers, url, {});
            return Promise.resolve();

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async verifyOtpForResetPassword(email: string, otp: string): Promise<Buyer> {
        let url = this.serverConfig.buyerAPIs.verifyOtpResetPasswordAPI + email;
        let headers = this.networkUtils.addCommonHeaders({});

        try {

            let buyersResponse = await this.apiHandler.makePostRequest(headers, url, {otp});
            let buyer = (new AuthAPIHandler()).performPostLoginFlow(buyersResponse);
            return Promise.resolve(buyer);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async updateBuyer(detailsToUpdate: any): Promise<Buyer> {
        let url = this.serverConfig.buyerAPIs.updateBuyer;
        let authheaders = this.networkUtils.addAuthHeaders({});

        try {

            let buyersResponse = await this.apiHandler.makePutRequest(authheaders, url, detailsToUpdate);
            let buyerData = buyersResponse.data.buyer;
            let buyer = new Buyer(buyerData);
            return Promise.resolve(buyer);

        } catch (err) {
            return Promise.reject(err);
        }
    }

}